/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".color-picker{margin-left:16px}.setup-theme .small-logo .image-container .img-thumbnail img{max-width:100px;height:auto;max-height:30px}.setup-theme .large-logo .image-container .img-thumbnail img{max-width:256px;height:auto;max-height:256px}.setup-theme .max-size-label{font-weight:700}.color-container{padding:0;position:relative}.color-container>input{padding-left:30px}.color-container .color-preview{background-color:#f0f0f0;width:24px;position:absolute;left:-1px;top:-1px;bottom:-1px;border:thin solid #cfcfcf;border-radius:.3rem 0 0 .3rem}"];
export { styles as styles };
